import axios from 'axios'
import Config from '@/settings'
import { message } from 'ant-design-vue'
import { getToken, getSecret, removeToken } from '@/utils/'



const jsonHeaders = {
  'Content-Type': 'application/json;charset=UTF-8'
}

const fileHeaders = {
   'Content-Type':'multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW'
}
axios.baseUrl = 'http: xxx.s'
// 创建axios实例
const httpService = axios.create({
  // url前缀
  // baseURL,
  // 请求超时时间
  timeout: Config.timeout
})

const redirectToLogin = () => {
  removeToken()
  if (window.location.hash === '#/login') return
  window.location.replace('/#/login')
}

const isLoginExpired = (response) => {
  const businessCode = response && response.data && response.data.code
  const httpStatus = response && response.status
  return Number(businessCode) === 130 || httpStatus === 401
}


// request拦截器
httpService.interceptors.request.use(
  (config) => {
    if(config.apiType != null && config.apiType === 'file'){
      config.headers = fileHeaders
    }else{
      config.headers = jsonHeaders
    }
    let token = getToken()
    let secret = getSecret()
    if (token) {
      config.headers.token = token
    }
    if (secret) {
      config.headers.secret = secret
    }
    return config
  },
  (error) => {
    // 请求错误处理
    Promise.reject(error)
  }
)

// response拦截器
httpService.interceptors.response.use(
  (response) => {
    // 登录失效后直接清理认证信息并跳转登录页。
    if (isLoginExpired(response)) {
      redirectToLogin()
      return response.data
    }
    // 统一处理状态
    return response.data
  },
  // 处理处理
  (error) => {
    if (isLoginExpired(error.response)) {
      redirectToLogin()
    }
    return Promise.reject(error)
  }
)

export function onHttpResponse(res) {
  if (res.code === 200) {
    message.success(res.msg)
    return Promise.resolve(res)
  } else {
    message.error(res.msg)
    return Promise.reject(res)
  }
}

export function onHttpResponseSilent(res) {
  if (res.code === 200) {
    return Promise.resolve(res)
  } else {
    message.error(res.msg)
    return Promise.reject(res)
  }
}

export default httpService
